import PropTypes from 'prop-types';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import FormHelperText from '@material-ui/core/FormHelperText';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import { isEmpty, get, debounce } from 'lodash';
import SaveButton from '../SaveButton/SaveButton';
import SimpleInputField from '../SimpleTextField/SimpleTextField';

const styles = theme => ({
  root         : {
    flexGrow : 1,
    width    : '99%',
    padding  : '12px',
    margin   : '12',
    fontSize : '16px',
  },
  paper        : {
    padding : 12,
  },
  control      : {
    padding : theme.spacing.unit * 2,
  },
  title        : {
    fontSize : '18px',
    color    : '#fff',
  },
  textField    : {
    fontSize : '24px',
    margin   : '12px',
  },
  toggleButton : {
    fontSize : '24px',
    margin   : '12px',
  },
  form         : {
    display       : 'flex',
    flexDirection : 'column',
  },
  listItem     : {
    display       : 'flex',
    flexDirection : 'row',
    padding       : 0,
  },
  typo         : {
    margin         : '10px',
    textDecoration : 'underline',
  },
});

class ESignatureForm extends React.Component {
  submitComp = debounce(event => {
    const { company, submitCompany, generateCompanyPayload } = this.props;
    submitCompany(generateCompanyPayload(company.data), company, event);
  }, 2000);

  constructor (props) {
    super(props);
    props.submitCompany.bind(this);
  }

  componentWillMount = () => {
    const { company, match, loadCompany } = this.props;
    if (get(company, 'data[id]', null) !== match.params.id) {
      loadCompany(match.params.id);
    }
  };

  componentWillReceiveProps = nextProps => {
    const { match, loadCompany } = this.props;
    if (match.params.id !== nextProps.match.params.id) {
      loadCompany(match.params.id);
    }
  };

  renderLoading = classes => (
    <div>
      <CircularProgress className={classes.progress} />
    </div>
  );

  render () {
    const { company, updateCompany, classes } = this.props;
    const { success, loading, error } = company;
    if (isEmpty(company) || isEmpty(company.data)) return this.renderLoading(classes);
    return (
      <div className={classes.root}>
        <Grid container spacing={24}>
          <Grid item xs={6}>
            <br />
            <AppBar position="static" color="primary">
              <h1 className={classes.title}>&nbsp;Hello Sign Configuration</h1>
            </AppBar>
            <Paper>
              <SimpleInputField id="esig_client_id" label="Client ID" data={company.data} action={updateCompany} />
              <SimpleInputField id="esig_api_key" label="API Key" data={company.data} action={updateCompany} />
              <SimpleInputField
                type="number"
                id="esig_test_mode"
                label="Test Mode"
                data={company.data}
                action={updateCompany}
              />
              <SimpleInputField
                id="esig_allow_decline"
                label="Allow Decline?"
                data={company.data}
                action={updateCompany}
                type="number"
              />
              <SimpleInputField
                id="esig_nda_template_id"
                label="NDA Template ID"
                data={company.data}
                action={updateCompany}
              />
            </Paper>
          </Grid>
        </Grid>
        <Grid container spacing={24}>
          <Grid item xs={6}>
            <br />
            <AppBar position="static" color="primary">
              <h1 className={classes.title}>&nbsp;Docusign Configuration</h1>
            </AppBar>
            <Paper>
              <SimpleInputField
                  id="esig_docusign_jwt_integration_key"
                  label="JWT / Integration Key"
                  data={company.data}
                  action={updateCompany}
              />
              <SimpleInputField
                  id="esig_docusign_secret_key"
                  label="Secret Key"
                  data={company.data}
                  action={updateCompany}
              />
              <SimpleInputField
                  id="esig_docusign_authorization_server"
                  label="Auth Server"
                  data={company.data}
                  action={updateCompany}
              />
              <SimpleInputField
                  id="esig_docusign_aud"
                  label="AUD Endpoint"
                  data={company.data}
                  action={updateCompany}
              />
              <SimpleInputField
                  id="esig_docusign_impersonated_user_guid"
                  label="Impersonated GUID"
                  data={company.data}
                  action={updateCompany}
              />
              <SimpleInputField
                  id="esig_docusign_target_account_id"
                  label="Target Account"
                  data={company.data}
                  action={updateCompany}
              />
              <SimpleInputField
                  id="esig_docusign_nda_template_id"
                  label="NDA Template ID"
                  data={company.data}
                  action={updateCompany}
              />
              <SimpleInputField
                  id="esig_docusign_application_ping_url"
                  label="Application URL"
                  data={company.data}
                  action={updateCompany}
              />
            </Paper>
            <SaveButton onSubmit={e => this.submitComp(e)} success={success} success={loading} label="Save" />
            {error && <FormHelperText>{error}</FormHelperText>}
          </Grid>
        </Grid>
      </div>
    );
  }
}

ESignatureForm.propTypes = {
  company                : PropTypes.object.isRequired,
  updateCompany          : PropTypes.func.isRequired,
  submitCompany          : PropTypes.func.isRequired,
  classes                : PropTypes.object.isRequired,
  generateCompanyPayload : PropTypes.func.isRequired,
  loadCompany            : PropTypes.func.isRequired,
  params                 : PropTypes.object.isRequired,
  match                  : PropTypes.object.isRequired,
};

export default withStyles(styles)(ESignatureForm);
